<template>
  <div>
    <div
      class="login-content"
      v-if="!loginStatus"
      :class="{ register: handleType == 'register' }"
    >
      <div class="caption">个人登录</div>
      <div class="login-info">
        <div class="form">
          <template v-if="handleType == 'login'">
            <div class="input-item">
              <i class="el-icon-mobile-phone"></i>
              <input
                maxlength="11"
                autocomplete="off"
                placeholder="个人账号"
                type="number"
                v-model="loginInfo.phoneNum"
              />
              <span class="tips">{{ loginInfo.phoneNum.length }}/18</span>
            </div>
            <div class="input-item">
              <i class="el-icon-lock"></i>
              <input
                autocomplete="off"
                placeholder="请输入密码"
                type="password"
                v-model="loginInfo.password"
              />
            </div>
          </template>
          <!---------->
          <template v-else>
            <div class="input-item">
              <i class="el-icon-mobile-phone"></i>
              <input
                maxlength="11"
                autocomplete="off"
                placeholder="手机号"
                type="number"
                v-model="registerInfo.phoneNum"
              />
              <span class="tips">{{ registerInfo.phoneNum.length }}/11</span>
            </div>
            <div class="input-item">
              <i class="el-icon-lock"></i>
              <input
                autocomplete="off"
                placeholder="请输入密码"
                type="password"
                v-model="registerInfo.password"
              />
            </div>

            <div class="psd-tips">密码设置: 8-30位, 字母+数字</div>
            <div class="input-item" style="margin-bottom: 20px">
              <i class="el-icon-lock"></i>
              <input
                autocomplete="off"
                placeholder="请再次输入密码"
                type="password"
                v-model="registerInfo.repassword"
              />
            </div>
            <!------>
            <div class="code-content flex-sb">
              <div class="input-item code">
                <i class="el-icon-lock"></i>
                <input
                  v-model="registerInfo.code"
                  autocomplete="off"
                  placeholder="验证码"
                  type="number"
                />
              </div>
              <div @click="clickSendCode" class="getcode flex-cc">
                {{ buttonText }}
              </div>
            </div>
          </template>
        </div>

        <div class="form-btn">
          <div
            class="forget"
            @click="handleType = 'forget'"
            v-if="handleType == 'login'"
          >
            忘记密码
          </div>
          <div class="codeTips" v-if="handleType == 'forget'">
            请使用短信验证码
          </div>
          <div class="flex-sb">
            <template v-if="handleType == 'login'">
              <div class="btn1" @click="handleVerify('login')">立即登录</div>
              <div class="btn2" @click="handleType = 'register'">注册</div>
            </template>

            <template v-else>
              <div class="btn1" @click="goRegister">
                {{ handleType == "register" ? "立即注册" : "立即重置" }}
              </div>
              <div class="btn2" @click="handleType = 'login'">返回</div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="userinfo-content" v-else>
      <div class="caption">用户信息</div>
      <div class="userinfo flex-fs">
        <div class="avatar">
          <img src="../assets/image/index/avatar.png" alt="" />
        </div>
        <div class="info">
          <div class="name">{{ userInfo && userInfo.userName }}</div>
          <div class="phoneNum">账号:{{ userInfo && userInfo.phoneNum }}</div>
        </div>
      </div>
      <div class="other-info flex-sb">
        <div class="info-item" @click="toPage('/myCourses')">
          <div class="icon">
            <img src="../assets/image/index/u1.png" alt="" />
          </div>
          <div class="title">我的课程</div>
        </div>
        <div
          class="info-item"
          @click="toPage('/usercenter', 'CertificateDownload')"
        >
          <div class="icon">
            <img src="../assets/image/index/u2.png" alt="" />
          </div>
          <div class="title">我的证书</div>
        </div>
        <div class="info-item" @click="toPage('/usercenter', 'Course')">
          <div class="icon">
            <img src="../assets/image/index/u3.png" alt="" />
          </div>
          <div class="title">我的收藏</div>
        </div>
      </div>
      <div class="logout" @click="goLogout">退出登录</div>
    </div>
    <!------->
    <Verify
      :captchaType="'blockPuzzle'"
      ref="verify"
      @success="capctchaCheckSuccess"
    />
  </div>
</template>

<script>
import { encrypt } from "@/utils/jsencrypt";
import { sendRegSms, register, sendFindSms, findUser } from "@/api";
import Verify from "@/utils/Verifition/Verify.vue";
export default {
  name: "Footer",
  components: { Verify },
  props: {
    loginStatus: Boolean,
    userInfo: Object,
  },
  data() {
    return {
      handleType: "login", //register forget
      clickType: "login",
      loginInfo: {
        phoneNum: "",
        password: "",
      },
      registerInfo: {
        phoneNum: "",
        password: "",
        repassword: "",
        code: "",
      },
      countdown: 60, // 初始倒计时秒数
      disabled: false, // 按钮是否禁用
      timer: null, // 定时器
    };
  },
  computed: {
    buttonText() {
      return this.disabled ? ` ${this.countdown} 秒` : "获取验证码";
    },
  },
  methods: {
    capctchaCheckSuccess(res) {
      if (this.clickType == "login") {
        this.goLogin(res.captchaVerification);
      } else if (this.clickType == "code") {
        this.requestSendRegSms(res.captchaVerification);
      }
    },
    clickSendCode() {

      const phoneReg = /^1[3-9]\d{9}$/;
      console.log("🚀 ~ clickSendCode ~ this.registerInfo:", this.registerInfo,!this.registerInfo.phoneNum)
      if (!this.registerInfo.phoneNum) {
        return this.errorTips("请输入手机号码");
      }
      if (!phoneReg.test(this.registerInfo.phoneNum)) {
        return this.errorTips("手机号码格式不正确");
      }

      this.handleVerify("code");
    },
    errorTips(message) {
      this.$notify({
        title: "提示",
        message,
        type: "warning",
      });
    },
    startCountdown() {
      if (this.disabled) return;
      this.disabled = true;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.reset();
        }
      }, 1000);
    },
    reset() {
      clearInterval(this.timer);
      this.timer = null;
      this.countdown = 60;
      this.disabled = false;
    },
    goLogin(code) {
      this.$emit("requestLogin", {
        phoneNum: encrypt(this.loginInfo.phoneNum),
        password: encrypt(this.loginInfo.password),
        code,
      });
    },
    goRegister() {
      const phoneReg = /^1[3-9]\d{9}$/;
      const passwordReg = /^(?=.*[a-zA-Z])(?=.*\d).{8,30}$/;
      if (!this.registerInfo.phoneNum) {
        return this.errorTips("请输入手机号码");
      }
      if (!phoneReg.test(this.registerInfo.phoneNum)) {
        return this.errorTips("手机号码格式不正确");
      }
      if (!this.registerInfo.password) {
        return this.errorTips("请输入密码");
      }
      if (!passwordReg.test(this.registerInfo.password)) {
        return this.errorTips("密码必须为8-30位,且包含字母和数字");
      }
      if (this.registerInfo.password != this.registerInfo.repassword) {
        return this.errorTips("两次密码不一致");
      }
      if (!this.registerInfo.code) {
        return this.errorTips("请输入验证码");
      }
      let data = {
        phoneNum: this.registerInfo.phoneNum,
        password: this.registerInfo.password,
        code: this.registerInfo.code,
      };
      if (this.handleType == "forget") {
        this.requestFindUser(data);
      } else {
        this.requestRegsiter(data);
      }
    },
    handleVerify(clickType) {
      const phoneReg = /^1[3-9]\d{9}$/;
      const passwordReg = /^(?=.*[a-zA-Z])(?=.*\d).{8,30}$/;
      if (clickType == 'login' && !this.loginInfo.phoneNum ||clickType =='code' && !this.registerInfo.phoneNum) {
        return this.errorTips("请输入手机号码");
      }
      if (clickType == 'login' && !phoneReg.test(this.loginInfo.phoneNum) || clickType =='code' && !phoneReg.test(this.registerInfo.phoneNum)) {
        return this.errorTips("手机号码格式不正确");
      }
      if (clickType == 'login' &&!this.loginInfo.password ) {
        return this.errorTips("请输入密码");
      }
      if (clickType == 'login' && !passwordReg.test(this.loginInfo.password)) {
        return this.errorTips("密码必须为8-30位,且包含字母和数字");
      }
      if ((clickType == "code" && !this.disabled) || clickType == "login") {
        this.$refs.verify.show();
        this.clickType = clickType;
      }
    },
    requestRegsiter(data) {
      register(data).then((res) => {
        if (res.code == 200) {
          this.$notify({
            title: "成功",
            message: "注册成功",
            type: "success",
          });
          setTimeout(() => {
            location.reload();
          }, 1000);
        }
      });
    },
    requestSendRegSms(code) {
      if (this.handleType == "forget") {
        sendFindSms({ code, phoneNum: this.registerInfo.phoneNum }).then(
          (res) => {
            if (res.code == 200) {
              this.startCountdown();
            }
          }
        );
      } else {
        sendRegSms({ code, phoneNum: this.registerInfo.phoneNum }).then(
          (res) => {
            if (res.code == 200) {
              this.startCountdown();
            }
          }
        );
      }
    },
    requestFindUser(data) {
      findUser(data).then((res) => {
        if (res.code == 200) {
          this.$notify({
            title: "成功",
            message: "重置成功",
            type: "success",
          });
          setTimeout(() => {
            location.reload();
          }, 1000);
        }
      });
    },
    toPage(path, showTemponent = "") {
      this.$router.push({
        path,
        query: { showTemponent },
      });
    },
    goLogout() {
      this.$confirm("请确认是否退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.setItem("token", null);
          localStorage.clear("userInfo");
          location.reload();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.login-content,
.userinfo-content {
  width: 425px;
  height: 475px;
  background: #fff;
  padding: 0 66px;
  .caption {
    padding-top: 56px;
    padding-bottom: 25px;
    margin: 0;
    text-align: center;
    font-weight: bold;
    color: #1265cc;
    font-size: 30px;
  }

  &.register {
    .input-item {
      &:nth-child(1) {
        margin-bottom: 12px !important;
      }
      &:nth-child(4) {
        margin-bottom: 15px;
      }
    }
  }
  .login-info {
    .input-item {
      padding-left: 17px;
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 290px;
      height: 40px;
      border: 1px solid #ddd;
      border-radius: 5px;
      &:nth-child(1) {
        margin-bottom: 20px;
      }

      i {
        color: #cccccc;
        font-size: 22px;
      }
      input {
        outline: none;
        border: 0;
        height: 38px;
        width: 180px;
        margin-left: 30px;
      }
      input:-internal-autofill-selected {
        background-color: transparent !important;
        color: inherit !important;
      }

      .tips {
        position: absolute;
        right: 10px;
        top: 10px;
        color: #ccc;
        font-size: 14px;
      }
    }
    .code-content {
      height: 40px;
      margin-bottom: 10px;
      .input-item.code {
        width: 170px;
        margin: 0 !important;
        input {
          width: 95px;
        }
      }
    }
    .psd-tips {
      color: #ddd;
      font-size: 14px;
      line-height: 26px;
      padding: 4px 0;
    }
    .getcode {
      width: 110px;
      height: 38px;
      background: #0076ca;
      color: #fff;
      font-size: 18px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
  .form-btn {
    .forget {
      color: #007bee;
      font-size: 16px;
      text-align: right;
      padding-top: 20px;
      padding-bottom: 18px;
      cursor: pointer;
    }
    .codeTips {
      font-size: 16px;
      text-align: left;
      padding-top: 5px;
      padding-bottom: 15px;
      cursor: pointer;
    }
    .btn1,
    .btn2 {
      width: 135px;
      height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      border-radius: 5px;
      cursor: pointer;
    }
    .btn1 {
      background: #007bee;
      color: #fff;
    }
    .btn2 {
      color: #007bee;
      border: 1px solid #007bee;
    }
  }
}
.userinfo-content {
  padding: 0 25px;
  .caption {
    margin-bottom: 15px;
  }
  .userinfo {
    width: 373px;
    height: 102px;
    border: 1px solid #ddd;
    background: #f8fbff;

    .avatar {
      margin-left: 25px;
      margin-right: 16px;
      img {
        width: 65px;
        height: 64px;
        vertical-align: middle;
      }
    }
    .info {
      .name {
        margin-bottom: 12px;
        font-size: 18px;
        color: #000;
      }
      .phoneNum {
        font-size: 16px;
        color: #999;
      }
    }
  }
  .other-info {
    margin-top: 18px;
    margin-bottom: 22px;
    .info-item {
      cursor: pointer;
      padding-top: 15px;
      text-align: center;
      width: 112px;
      height: 112px;
      border: 1px solid #ddd;
      background: #f8fbff;
      border-radius: 18px;
      .avatar {
        height: 60px;
        img {
          width: 60px;
          height: auto;
        }
      }

      .title {
        margin-top: 2px;
        font-size: 18px;
        color: #000;
      }
    }
  }
  .logout {
    cursor: pointer;
    float: right;
    color: #007bee;
    border: 1px solid #007bee;
    width: 135px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>
